<template>
  <div ref="app" class="vueMapInstance" v-if="loaded">
    <h2 class="headline">Infektionsfälle in den Landkreisen</h2>
    <p class="subheadline" v-if="view === 'new'">Neuinfektionen pro 100.000 Einwohner in den letzten sieben Tagen</p>
    <p class="subheadline" v-else-if="view === 'hotspots'">Neuinfektionen pro 100.000 Einwohner in den letzten sieben Tagen</p>
    <p class="subheadline" v-else>Fälle pro 100.000 Einwohner</p>

    <div class="grid-x grid-margin-x relative">
      <div class="cell small-12 medium-7  map"> <!-- medium-offset-1 -->
        <!-- <div class="viewSelect">
          <input type="radio" id="hotspots" value="hotspots" v-model="view">
          <label for="hotspots">Hotspots</label> -->
          <!-- <input type="radio" id="new" value="new" v-model="view">
          <label for="new">Letzte sieben Tage</label> -->
          <!-- <input type="radio" id="cumulated" value="cumulated" v-model="view">
          <label for="cumulated">Gesamt</label>
        </div> -->
        <div class="">
          <choropleth v-if="map" 
            :map="map" 
            :blmap="BLmap" 
            v-model="hover" 
            :selectedRegion="selectedRegion" 
            :view="view" 
            :domain="[0, 500, 1000]" 
            :range="['#6FA746', '#FFD882', '#C51D1E']">
          </choropleth>

          <!-- <div class="tooltip" v-if="hover" :style="{'left': hover.x + 'px', 'top': hover.y-20 + 'px'}">
            <span class="tooltip_headline">{{hover.name}}</span>
            <table>
              <tr>
                <td>Fälle / 100.000 Einw.</td><td>{{ hover.cases_per_100k }}</td>
              </tr>
              <tr>
                <td>Bestätigte Infektionen</td><td>{{ hover.cases }}</td>
              </tr>
              <tr>
                <td>Todesfälle</td><td>{{ hover.deaths }}</td>
              </tr>
            </table>
          </div> -->
        </div>
      </div>
      <div class="cell small-12 medium-5 region">

        <div class="regionSelect">
          <multiselect 
            v-model="selectedRegion" 
            :options="data" 
            :show-labels="false" 
            placeholder="Landkreis / kreisfreie Stadt suchen"
            track-by="OBJECTID" 
            label="GEN"
            @select="select">
          </multiselect>
        </div>

        <div class="regionData" v-if="hover || $mq !== 'small'">
          <div class="regionData_headline">{{activeRegion.GEN}}</div>
          <div class="regionData_subheadline"><span v-if="activeRegion.BEZ">{{activeRegion.BEZ}} · </span>{{activeRegion.BL}}</div>
          <table>
            <tr v-if="view != 'cumulated'">
              <td>Neue Fälle pro 100.000 Einwohner in den letzten sieben Tagen</td><td><b :style="colorStyle(activeRegion.cases7_per_100k)">{{ round(activeRegion.cases7_per_100k) }}</b></td>
            </tr>
            <tr v-else>
              <!-- <td>Fälle pro 100.000 Einwohner</td><td><b>{{ round(activeRegion.cases_per_100k) }}</b></td> -->
            </tr>
            <tr v-if="view == 'cumulated'">
              <td>Kumulierte Fälle</td><td>{{ format(activeRegion.cases) }}</td>
            </tr>
            <tr v-if="view == 'cumulated'">
              <td>Todesfälle</td><td>{{ format(activeRegion.deaths) }}</td>
            </tr>
          </table>  
          <div class="regionData_close" @click="closeRegionData">×</div>
        </div>

        <div class="highestIncidences">
          <div class="highestIncidences_headline">Landkreise mit den meisten Neuinfektionen</div>
          <div class="highestIncidences_subheadline">in den letzten sieben Tagen</div>
          <table>
            <tr>
              <td>Landkreis</td>
              <!-- <td>Bundesland</td> -->
              <td>Inzidenz</td>
            </tr>
            <tr v-for="lk in highestIncidences" v-bind:key="lk.GEN">
              <td>{{formatLK(lk.county, lk.BL)}}</td>
              <td :style="colorStyle(lk.cases7_per_100k)">{{round(lk.cases7_per_100k)}}</td>
            </tr>
          </table>
        </div>

      </div>
    </div>

    <p class="footnote">Zuletzt aktualisiert am {{lastUpdated}} / Grafik:&nbsp;Giesel / Quelle:&nbsp;Robert-Koch-Institut</p>
  </div>
</template>

<script>
import {csvParse} from 'd3'
import {format} from 'd3'
// import {TweenLite} from 'gsap'

import Choropleth from './components/Choropleth.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'app',
  components: {
    Choropleth,
    Multiselect
  },
  props: ['startdata'],
  data () {
    return {
      // dataUrl: process.env.BASE_URL + 'data/RKI_Corona_Landkreise.csv',
      // dataUrl: process.env.BASE_URL + 'data/incidence_lk.json',
      mapUrl: process.env.BASE_URL + 'data/RKI_Corona_Landkreise.geojson',
      BLmapUrl: process.env.BASE_URL + 'data/bl.geojson',
      data: [],
      loaded: false,
      hover: null,
      map: null,
      BLmap: null, 
      average: null,
      selectedRegion: null,
      view: 'hotspots'
    }
  },
  methods: {
    parseCsv (csv) {
      return csvParse(csv)
    },
    format (number) {
      return format(",")(number).replace(',','.')
    },
    formatLK (lk, bl) {
      if(bl == "Berlin" || bl == "Hamburg" || bl == "Bremen") {
        return lk.replace('SK', '')
      } else {
        let string = lk + ', ' + bl
        return string.replace('LK ','').replace('SK ','Stadt ')
      }
    },
    millions (number) {
      return String(Math.round(number/100000)/10).replace('.',',') + ' Mio.'
    },
    round(string) {
      return String(Math.round(parseFloat(string)*10)/10).replace('.',',')
    },
    calculateAverage () {
      let population = this.data.reduce( (sum, row) => {
        let summe = sum + parseInt(row.EWZ)
        return summe
      }, 0)
      // console.log("pop: ", population)
      let cases = this.data.reduce( (sum, row) => {
        let summe = sum + parseInt(row.cases)
        return summe
      }, 0)
      let deaths = this.data.reduce( (sum, row) => {
        let summe = sum + parseInt(row.deaths)
        return summe
      }, 0)
      let casesSeven = this.data.reduce( (sum, row) => {
        let summe = sum + parseFloat(row.cases7_lk)
        return summe
      }, 0)
      // console.log("casesSeven: ", casesSeven)
      // let casesSevenPerK = this.data.reduce( (sum, row) => {
      //   let summe = sum + parseFloat(row.cases7_per_100k)
      //   return summe
      // }, 0)

      this.average = {
        // 'cases_per_100k': cases/population*100000, 
        'cases7_per_100k': casesSeven/population*100000, 
        'cases': cases, 
        'deaths': deaths
      }
    },
    closeRegionData () {
      this.hover = null
    },
    select () {
      this.hover = 42
      // this.activeRegion = this.selectedRegion
    },
    populateRegions () {
      this.map.features.forEach(f => {
        let match = this.data.find(d => parseInt(d.OBJECTID) === f.properties.OBJECTID)
        // console.log(match)
        // f.properties.cases_per_100k = match.cases_per_100k
        f.properties.cases7_per_100k = match.cases7_per_100k
        f.properties.cases = match.cases
        f.properties.deaths = match.deaths
      })
    },
    colorStyle (value) {
      if (value < 10) {
        return "color: #6FA746"
      } else if (value < 35) { 
        return "color: #A5CE81"
      } else if (value < 50) { 
        return "color: #EDBF57"
      } else if (value < 100) { 
        return "color: #ED7D38"
      } else if (value >= 100) { 
        return "color: #D13D3D"
      } else {
        return "" 
      }
    } 
  },
  mounted () {
    const data_url = process.env.NODE_ENV == 'development' ? 
      'data/incidence_lk.json' :
      'https://cdn.faz-azure.com/multimediaredaktion/corona/incidence_lk.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'
    let fetches = [
      fetch(data_url).then(r => r.json()),
      fetch(this.mapUrl).then(r => r.json()),
      fetch(this.BLmapUrl).then(r => r.json())
    ]
    Promise.all(fetches).then((results) => {
      this.data = results[0].map( el => el.attributes)
      // this.data = this.parseCsv(results[0]).sort( (a, b) => {
      //   let nameA = a.GEN.toUpperCase(); // Groß-/Kleinschreibung ignorieren
      //   let nameB = b.GEN.toUpperCase(); // Groß-/Kleinschreibung ignorieren
      //   if (nameA < nameB) {
      //     return -1;
      //   }
      //   if (nameA > nameB) {
      //     return 1;
      //   }
      //   // Namen müssen gleich sein
      //   return 0;
      // })
      this.map = results[1]
      this.BLmap = results[2]
      this.populateRegions()
      this.calculateAverage()
      this.loaded = true
    })
  },
  watch: {
    // hover: function () {
    //   // this.selectedRegion = this.data.find( el => el.OBJECTID == this.hover.OBJECTID)
    // }
  },
  computed: {
    lastUpdated: function () {
      return this.data[0].last_update.slice(0,10)
    },
    activeRegion: function () {
      if (this.hover === 42) {
        return this.selectedRegion
      }
      if (this.hover !== null) {
        return this.data.find( el => parseInt(el.OBJECTID) === this.hover.OBJECTID)
      }
      if (this.hover === null && this.selectedRegion === null) {
        return { 
          GEN: 'Bestätigte Covid-19 Fälle',
          BL: 'deutschlandweit‎',
          cases: this.average.cases,
          // cases_per_100k: this.average.cases_per_100k,
          cases7_per_100k: this.average.cases7_per_100k,
          deaths: this.average.deaths
        }
      }
      if (this.selectedRegion !== null && this.hover === null ) {
        return this.selectedRegion
      }
      else { return this.selectedRegion }
    },
    highestIncidences: function () {
      const sorted = [...this.data].sort( (regionA, regionB) => {
        let a = parseFloat(regionA.cases7_per_100k)
        let b = parseFloat(regionB.cases7_per_100k)
        return b - a
      }).slice(0,10)

      return sorted
    }
  }
}
</script>

<style scoped src="./assets/foundation.css">
</style>

<style scoped lang="scss">
@import './assets/reset.scss';
@import './assets/vue-multiselect.min.css';
@import './assets/style.scss';
</style>

<style>
.multiselect__single {
  color: #999;
}

.multiselect__tags {
  border-color: #ddd;
}
</style>